import { render, staticRenderFns } from "./NsrItemModuleDataPoint.vue?vue&type=template&id=6cf70d9a"
import script from "./NsrItemModuleDataPoint.vue?vue&type=script&lang=js"
export * from "./NsrItemModuleDataPoint.vue?vue&type=script&lang=js"
import style0 from "./NsrItemModuleDataPoint.vue?vue&type=style&index=0&id=6cf70d9a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports